import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth relies exclusively on HttpOnly + Secure + SameSite=None cookies set
// by the backend (see backend/auth.py::_set_auth_cookies). No client-side
// token storage — mitigates XSS-based token exfiltration.
const http = axios.create({ baseURL: API, withCredentials: true });

// Super-admin org switcher: when set, every request carries X-Org-Slug so the
// backend renders the chosen tenant's data. Persisted across reloads.
const ORG_VIEW_KEY = "cv_org_view";
export const getOrgView = () => localStorage.getItem(ORG_VIEW_KEY) || "";
export const setOrgView = (slug) => {
  if (slug) localStorage.setItem(ORG_VIEW_KEY, slug);
  else localStorage.removeItem(ORG_VIEW_KEY);
};

http.interceptors.request.use((config) => {
  const slug = getOrgView();
  if (slug) config.headers["X-Org-Slug"] = slug;
  return config;
});

export const apiGet = async (path, params) => {
  const r = await http.get(path, { params });
  return r.data;
};

export const apiPost = async (path, body) => {
  const r = await http.post(path, body);
  return r.data;
};

export const apiPatch = async (path, body) => {
  const r = await http.patch(path, body);
  return r.data;
};

export const apiDelete = async (path) => {
  const r = await http.delete(path);
  return r.data;
};
